import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { ReactNode, useEffect } from "react";
import { InteractionStatus } from "@azure/msal-browser";
import CustomSpinner from "../components/custom-spinner/CustomSpinner";
import AdminAuthGuard from "../auth/admin-auth/AdminAuthGaurd";
import { ThemeProvider } from "@mui/material";
import companyTheme, { patientTheme } from "../styles/theme";
import { SnackbarProvider } from "notistack";
import ThemeResponsiveSnackbar from "../components/custom-snackbar/ThemeResponsiveSnackbar";
const AdminProtectedRoute = ({ children }: { children: ReactNode }) => {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress, instance } = useMsal();

  // Automatically trigger SSO login if not authenticated and no interaction is in progress.
  useEffect(() => {
    if (!isAuthenticated && inProgress === InteractionStatus.None) {
      instance.loginRedirect();
    }
  }, [isAuthenticated, inProgress, instance]);

  if (inProgress !== InteractionStatus.None) {
    return <CustomSpinner />;
  }

  // If not authenticated, still show a spinner (the redirect should kick in)
  if (!isAuthenticated) {
    return <CustomSpinner />;
  }

  return (
    <ThemeProvider theme={patientTheme}>
      <SnackbarProvider
        anchorOrigin={{ horizontal: "center", vertical: "top" }}
        Components={{
          success: ThemeResponsiveSnackbar,
          error: ThemeResponsiveSnackbar,
        }}
        autoHideDuration={5000}
        maxSnack={1}
      >
        <AdminAuthGuard>{children}</AdminAuthGuard>
      </SnackbarProvider>
    </ThemeProvider>
  );
};

export default AdminProtectedRoute;
